// extracted by mini-css-extract-plugin
export default {"tracks":"Tracks_tracks__zPa8M","tracks__title":"Tracks_tracks__title__TQot2","tracks__list":"Tracks_tracks__list__jpVaE"};